<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="6">
					<sf-input-group
						:label="getMessage_('MWCC000151')"
						:inputValue="searchParams.commCd"
						:onChange="value => onChangeSearchParam({ key: 'commCd', value })"
					/>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/ComCdPopup/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	async created() {
		await this.searchList();
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		searchList() {
			this.$sf_toggleLoading(true);
			this.getCompPopup_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		onChangeSearchParam({ key, value }) {
			this.setSearchParam_({ key, value });
		}
	}
};
</script>

<style></style>
